module.exports = __webpack_public_path__ + "img/upholstery.4236f6d3.png";